<template>
  <button
    type="button"
    class="inline-flex h-11 w-11 items-center justify-center rounded-lg transition hover:brightness-110 active:scale-95"
    aria-label="Open menu"
    @click="emit('click')"
  >
    <div class="flex h-[21px] w-[28px] flex-col justify-between">
      <div class="h-[5px] w-[28px] rounded-md bg-[#2E234B]"></div>
      <div class="h-[5px] w-[28px] rounded-md bg-[#2E234B]"></div>
      <div class="h-[5px] w-[28px] rounded-md bg-[#2E234B]"></div>
    </div>
  </button>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: "click"): void;
}>();
</script>
